// extracted by mini-css-extract-plugin
export default {"seminarsList":"auxboUDRlT8sHmEl7HQz"};